export default {
  bdtx_get_detail_deployment: 'bdtx/kpi/get-detail-progress',
  bdtx_kpi_overview_deployment: 'bdtx/kpi/get-overview-progress',
};
